import {type HelpCenterPayload} from './types';

const REWARDS_COLLECTION_NAME = 'Rewards';

export const suppressRewardsContent = (payload: HelpCenterPayload): HelpCenterPayload => {
  const suppressedIds = new Set(
    payload.collections.filter(c => c.name === REWARDS_COLLECTION_NAME).map(c => c.id),
  );
  if (suppressedIds.size === 0) return payload;

  return {
    collections: payload.collections.filter(c => !suppressedIds.has(c.id)),
    articles: payload.articles.filter(a => !a.collectionIds.some(id => suppressedIds.has(id))),
  };
};
